export default [
  {
    path: '/error-404',
    name: 'error-404',
    component: () => import('@/views/error/Error404.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      action: 'read',
    },
  },
  {
    path: '/login',
    name: 'auth-login',
    component: () => import('@/views/pages/authentication/Login.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/pages/authentication/login-v1',
    name: 'auth-login-v1',
    component: () => import('@/views/pages/authentication/Login-v1.vue'),
    meta: {
      layout: 'full',
    },
  },
  {
    path: '/pages/authentication/login-v2',
    name: 'auth-login-v2',
    component: () => import('@/views/pages/authentication/Login-v2.vue'),
    meta: {
      layout: 'full',
    },
  },
  {
    path: '/register',
    name: 'auth-register',
    component: () => import('@/views/pages/authentication/Register.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/pages/authentication/register-v1',
    name: 'auth-register-v1',
    component: () => import('@/views/pages/authentication/Register-v1.vue'),
    meta: {
      layout: 'full',
    },
  },
  {
    path: '/pages/authentication/register-v2',
    name: 'auth-register-v2',
    component: () => import('@/views/pages/authentication/Register-v2.vue'),
    meta: {
      layout: 'full',
    },
  },
  {
    path: '/forgot-password',
    name: 'auth-forgot-password',
    component: () => import('@/views/pages/authentication/ForgotPassword.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/reset-password',
    name: 'auth-reset-password',
    component: () => import('@/views/pages/authentication/ResetPassword.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/pages/authentication/forgot-password-v1',
    name: 'auth-forgot-password-v1',
    component: () => import('@/views/pages/authentication/ForgotPassword-v1.vue'),
    meta: {
      layout: 'full',
    },
  },
  {
    path: '/pages/authentication/forgot-password-v2',
    name: 'auth-forgot-password-v2',
    component: () => import('@/views/pages/authentication/ForgotPassword-v2.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
    },
  },
  {
    path: '/pages/authentication/reset-password-v1',
    name: 'auth-reset-password-v1',
    component: () => import('@/views/pages/authentication/ResetPassword-v1.vue'),
    meta: {
      layout: 'full',
    },
  },
  {
    path: '/pages/authentication/reset-password-v2',
    name: 'auth-reset-password-v2',
    component: () => import('@/views/pages/authentication/ResetPassword-v2.vue'),
    meta: {
      layout: 'full',
    },
  },
  {
    path: '/pages/miscellaneous/coming-soon',
    alias: '/coming-soon',
    name: 'misc-coming-soon',
    component: () => import('@/views/pages/miscellaneous/ComingSoon.vue'),
    meta: {
      layout: 'full',
    },
  },
  {
    path: '/pages/miscellaneous/not-authorized',
    alias: '/not-authorized',
    name: 'misc-not-authorized',
    component: () => import('@/views/pages/miscellaneous/NotAuthorized.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
    },
  },
  {
    path: '/pages/miscellaneous/under-maintenance',
    alias: '/under-maintenance',
    name: 'misc-under-maintenance',
    component: () => import('@/views/pages/miscellaneous/UnderMaintenance.vue'),
    meta: {
      layout: 'full',
    },
  },
  {
    path: '/pages/miscellaneous/error',
    alias: '/error',
    name: 'misc-error',
    component: () => import('@/views/pages/miscellaneous/Error.vue'),
    meta: {
      layout: 'full',
    },
  },
  {
    path: '/admin/profile',
    name: 'profile-account-setting',
    component: () => import('@/views/pages/account-setting/AccountSettingGeneral.vue'),
    meta: {
      // pageTitle: 'Profile',
      HideHomeIcon:true,
      breadcrumb: [
        {
          text: 'Home',
          to:'/dashboard'
        },
        {
          text: 'My Profile',
          active: true,
        },
      ],
    },
  },
  {
    path: '/admin/profile/edit',
    name: 'profile-edit-account-setting',
    component: () => import('@/views/pages/account-setting/AccountSettingEdit.vue'),
    meta: {
      HideHomeIcon: true,
      breadcrumb: [
        {
          text: 'Home',
          to: '/dashboard',
        },
        {
          text: 'My Profile',
          to: '/admin/profile',
        },
        {
          text: 'Edit Profile',
          active: true,
        },
      ],
    },
  },
  {
    path: '/admin/changepassword',
    name: 'password-account-setting',
    component: () => import('@/views/pages/account-setting/AccountSettingPassword.vue'),
    meta: {
      HideHomeIcon:true,
      breadcrumb: [
        {
          text:'Home',
          to:'/dashboard'
        },
        {
          text: 'My Profile',
          to:'/admin/profile'
        },
        {
          text: 'Change Password',
          active: true,
        },
      ],
    },
  },
  {
    path: '/admin/settings',
    name: 'account-setting',
    component: () => import('../../features/settings/pages/settingMain.vue'),
    meta: {
      HideHomeIcon:true,
      breadcrumb: [
        {
          text:'Home',
          to:'/dashboard'
        },
        {
          text: 'My Profile',
          to:'/admin/profile'
        },
        {
          text: 'Settting',
          active: true,
        },
      ],
    },
  },
  {
    path: '/pages/profile',
    name: 'pages-profile',
    component: () => import('@/views/pages/profile/Profile.vue'),
    meta: {
      HideHomeIcon:true,
      pageTitle: 'Profile',
      breadcrumb: [
        {
          text: 'Pages',
        },
        {
          text: 'Profile',
          active: true,
        },
      ],
    },
  },

  {
    path: '/faq',
    name: 'pages-faq',
    component: () => import('@/views/pages/faq/Faq.vue'),
    meta: {
      HideHomeIcon:true,
      breadcrumb: [
        {
          text: 'Home',
          to:'/dashboard'
        },{
          text:'Profile',
          to:'/admin/profile'
        },
        {
          text: 'FAQS',
          active: true,
        },
      ],
    },
  },
  {
    path: '/help',
    name: 'pages-help',
    component: () => import('@/views/pages/help/Help.vue'),
    meta: {
      HideHomeIcon:true,
      breadcrumb: [
        {
          text:'Home',
          to:'/dashboard'
        },
        {
          text: 'My Profile',
          to:'/admin/profile'
        },
        {
          text: 'HELP',
          active: true,
        },
      ],
    },
  },
  {
    path: '/pages/knowledge-base',
    name: 'pages-knowledge-base',
    component: () => import('@/views/pages/Knowledge-base/KnowledgeBase.vue'),
    meta: {
      HideHomeIcon:true,
      pageTitle: 'Knowledge Base',
      breadcrumb: [
        {
          text: 'Pages',
        },
        {
          text: 'Knowledge Base',
          active: true,
        },
      ],
    },
  },
  {
    path: '/pages/knowledge-base/:category',
    name: 'pages-knowledge-base-category',
    component: () => import('@/views/pages/Knowledge-base/KnowledgeBaseCategory.vue'),
    meta: {
      pageTitle: 'Category',
      breadcrumb: [
        {
          text: 'Pages',
        },
        {
          text: 'Knowledge Base',
          to: '/pages/Knowledge-base',
        },
        {
          text: 'Category',
          active: true,
        },
      ],
      navActiveLink: 'pages-knowledge-base',
    },
  },
  {
    path: '/pages/knowledge-base/:category/:slug',
    name: 'pages-knowledge-base-question',
    component: () => import('@/views/pages/Knowledge-base/KnowledgeBaseCategoryQuestion.vue'),
    meta: {
      pageTitle: 'Question',
      breadcrumb: [
        {
          text: 'Pages',
        },
        {
          text: 'Knowledge Base',
          to: '/pages/Knowledge-base',
        },
        {
          text: 'Category',
          to: '/pages/Knowledge-base/category',
        },
        {
          text: 'Question',
          active: true,
        },
      ],
      navActiveLink: 'pages-knowledge-base',
    },
  },
  {
    path: '/pages/pricing',
    name: 'pages-pricing',
    component: () => import('@/views/pages/pricing/Pricing.vue'),
    meta: {
      HideHomeIcon: true,
      breadcrumb: [
        {
          text: 'Home',
          to: '/dashboard',
        },
        {
          text: 'My Profile',
          to: '/admin/profile',
        },
        {
          text: 'Plans',
          active: true,
        },
      ],
    },
  },
  {
    path: '/pages/pricing/add',
    name: 'pages-pricing-add',
    component: () => import('@/views/pages/pricing/PricingEdit.vue'),
    meta: {
      HideHomeIcon: true,
      breadcrumb: [
        {
          text: 'Home',
          to: '/dashboard',
        },
        {
          text: 'My Profile',
          to: '/admin/profile',
        },
        {
          text: 'Plans',
          to: '/pages/pricing',
        },
        {
          text: 'Add Plan',
          active: true,
        },
      ],
    },
  },
  {
    path: '/pages/pricing/edit/:id',
    name: 'pages-pricing-edit',
    component: () => import('@/views/pages/pricing/PricingEdit.vue'),
    meta: {
      HideHomeIcon: true,
      breadcrumb: [
        {
          text: 'Home',
          to: '/dashboard',
        },
        {
          text: 'My Profile',
          to: '/admin/profile',
        },
        {
          text: 'Plans',
          to: '/pages/pricing',
        },
        {
          text: 'Edit Plan',
          active: true,
        },
      ],
    },
  },
  {
    path: '/pages/blog/list',
    name: 'pages-blog-list',
    component: () => import('@/views/pages/blog/BlogList.vue'),
    meta: {
      pageTitle: 'Blog List',
      breadcrumb: [
        {
          text: 'Pages',
        },
        {
          text: 'Blog',
        },
        {
          text: 'List',
          active: true,
        },
      ],
    },
  },
  {
    path: '/pages/blog/:id',
    name: 'pages-blog-detail',
    component: () => import('@/views/pages/blog/BlogDetail.vue'),
    meta: {
      pageTitle: 'Blog Detail',
      breadcrumb: [
        {
          text: 'Pages',
        },
        {
          text: 'Blog',
        },
        {
          text: 'Detail',
          active: true,
        },
      ],
    },
  },
  {
    path: '/pages/blog/edit/:id',
    name: 'pages-blog-edit',
    component: () => import('@/views/pages/blog/BlogEdit.vue'),
    meta: {
      pageTitle: 'Blog Edit',
      breadcrumb: [
        {
          text: 'Pages',
        },
        {
          text: 'Blog',
        },
        {
          text: 'Edit',
          active: true,
        },
      ],
    },
  },
  {
    path: '/pages/kanban',
    name: 'pages-kanban',
    component: () => import('@/views/pages/kanban/Legal.vue'),
    meta: {
      pageTitle: 'Kanban',
      breadcrumb: [
        {
          text: 'Apps',
        },
        {
          text: 'Kanban',
          active: true,
        },
      ],
    },
  },
  {
    path: '/reports/ledger-statement',
    name: 'ledger-statement',
    component: () => import('@/views/pages/reports/LedgerStatement.vue'),
    meta: {
      pageTitle: 'Ledger Statement',
      breadcrumb: [
        {
          text: 'Apps',
        },
        {
          text: 'Ledger-statement',
          active: true,
        },
      ],
    },
  },
  {
    path: '/reports/project-planning',
    name: 'project-planning',
    component: () => import('@/features/reports/pages/Reports.vue'),
    meta: {
      pageTitle: 'Reports',
      HideHomeIcon: true,
      breadcrumb: [
        {
          text: 'Home',
          to: '/dashboard',
        },
        {
          text: 'Reports',
          active: true,
        },
      ],
    },
  },
  {
    path: '/reports/reported-by-users',
    name: 'reports-reported-by-users',
    component: () => import('@/features/reports/pages/ReportDetails.vue'),
    meta: {
      pageTitle: 'Reported by Users',
      HideHomeIcon: true,
      breadcrumb: [
        { text: 'Home', to: '/dashboard' },
        { text: 'Reports', to: '/reports/project-planning' },
      ],
    },
  },
  {
    path: '/reports/suspended-advertisers',
    name: 'reports-suspended-advertisers',
    component: () => import('@/features/reports/pages/ReportDetails.vue'),
    meta: {
      pageTitle: 'Suspended Advertisers',
      HideHomeIcon: true,
      breadcrumb: [
        { text: 'Home', to: '/dashboard' },
        { text: 'Reports', to: '/reports/project-planning' },
      ],
    },
  },
  {
    path: '/reports/suspended-users',
    name: 'reports-suspended-users',
    component: () => import('@/features/reports/pages/ReportDetails.vue'),
    meta: {
      pageTitle: 'Suspended Users',
      HideHomeIcon: true,
      breadcrumb: [
        { text: 'Home', to: '/dashboard' },
        { text: 'Reports', to: '/reports/project-planning' },
      ],
    },
  },
  {
    path: '/reports/users',
    name: 'reports-users',
    component: () => import('@/features/reports/pages/ReportDetails.vue'),
    meta: {
      pageTitle: 'Users',
      HideHomeIcon: true,
      breadcrumb: [
        { text: 'Home', to: '/dashboard' },
        { text: 'Reports', to: '/reports/project-planning' },
      ],
    },
  },
  {
    path: '/reports/reject-ads',
    name: 'reports-reject-ads',
    component: () => import('@/features/reports/pages/ReportDetails.vue'),
    meta: {
      pageTitle: 'Reject Ads',
      HideHomeIcon: true,
      breadcrumb: [
        { text: 'Home', to: '/dashboard' },
        { text: 'Reports', to: '/reports/project-planning' },
      ],
    },
  },
  {
    path: '/reports/ads',
    name: 'reports-ads',
    component: () => import('@/features/reports/pages/ReportDetails.vue'),
    meta: {
      pageTitle: 'Ads',
      HideHomeIcon: true,
      breadcrumb: [
        { text: 'Home', to: '/dashboard' },
        { text: 'Reports', to: '/reports/project-planning' },
      ],
    },
  },
  {
    path: '/reports/advertisers',
    name: 'reports-advertisers',
    component: () => import('@/features/reports/pages/ReportDetails.vue'),
    meta: {
      pageTitle: 'Advertisers',
      HideHomeIcon: true,
      breadcrumb: [
        { text: 'Home', to: '/dashboard' },
        { text: 'Reports', to: '/reports/project-planning' },
      ],
    },
  },
]
